// Auto-generated normalizer for table: ZonasGeograficas
export function zonasGeograficasNormalize(row) {
  return {
    idZonaGeografica: row.idZonaGeografica ?? row.IdZonaGeografica ?? row['IdZonaGeografica'] ?? 0,
    clave: row.clave ?? row.Clave ?? row['Clave'] ?? '',
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    idEmpresa: row.idEmpresa ?? row.IdEmpresa ?? row['IdEmpresa'] ?? null,
    nombreEmpresa: row.nombreEmpresa ?? row.NombreEmpresa ?? row['NombreEmpresa'] ?? '',
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['FechaCreacion'] ?? null,
    tieneUOs: !!(row.tieneUOs ?? row.TieneUOs ?? row['TieneUOs']),
    tieneEmpleados: !!(row.tieneEmpleados ?? row.TieneEmpleados ?? row['TieneEmpleados']),
  };
}
